import ShareComponent from './share.vue'

let $vm

export default {
    install (Vue) {
        const Share = Vue.extend(ShareComponent)

        if (!$vm) {
            $vm = new Share({el: document.createElement('div')})
            document.body.appendChild($vm.$el)
        }

        Vue.$sharepop= {
            open () {
                $vm.open()
            },
            close () {
                $vm.close()
            }
        }

        Vue.mixin({
            created () {
                this.$sharepop = Vue.$sharepop
            }
        })
    }
}
